import {
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";

const InputText = ({ formik, label, name, ...rest }: any) => {
  const { handleChange, handleBlur, values, touched, errors } = formik;

  return (
    <FormGroup className="mb-3">
      <Label htmlFor={name}>{label}</Label>
      <Input
        id={name}
        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        {...rest}
        invalid={touched[name] && !!errors[name]}
      />
      {touched[name] && errors[name] && (
        <FormFeedback>{errors[name]}</FormFeedback>
      )}
      {rest.children}
    </FormGroup>
  );
};

export default InputText;
